<template>
  <div class="fair-navigation">
    <bos-loader v-if="isLoading" relative inline />

    <template v-else>
      <ul class="navigation-list">
        <router-link
          v-for="fair in fairnavigation"
          :key="fair.id"
          :to="{ name: 'FairDetail', params: { code: fair.code } }"
          @click.prevent="toggleMe(fair)"
          :class="{ 'has-notifications': fair.hasNotifications }"
          tag="li"
        >
          <a @click.prevent="toggleMe(fair)" :class="{open:closedFairs.indexOf(fair.id) === -1}">{{ fair.name }}</a>
          <ul v-if="closedFairs.indexOf(fair.id) === -1">
            <router-link
              v-for="child in fair.children.sort((a, b) => {
                if (a.route.params.booth < b.route.params.booth) {
                  return 1
                } else if (a.route.params.booth > b.route.params.booth) {
                  return -1
                }
                return 0
              })"
              :key="child.id"
              :to="child.route"
              :class="{
                'is-new-route': child.isNewRoute,
                'has-notifications': child.hasNotifications
              }"
              tag="li"
            >
              <a>{{ child.name }}</a>
            </router-link>
          </ul>
        </router-link>
      </ul>
    </template>
  </div>
</template>

<script>
import ApiService from '@/services/ApiService'
import BosLoader from '@/components/BosLoader'
import { getLocalizationInExcludes, localize } from '@/assets/js/helper'

export default {
  name: 'fairnavigation',
  data() {
    return {
      closedFairs: []
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters['fair/isLoading']
    },
    fairs() {
      return this.$store.getters['fair/getWithBooths'].filter(item => {
        if (item === undefined) {
          return false
        }

        const startTime = new Date(item.publish.start)
        const endTime = new Date(item.publish.end)
        endTime.setUTCHours(23)
        endTime.setUTCMinutes(59)
        endTime.setUTCSeconds(59)
        endTime.setUTCMilliseconds(999)
        const now = new Date()
        return startTime <= now && endTime >= now
      })
    },
    language() {
      let loose = this.$i18n.locale.substr(0, 2)
      return loose.charAt(0).toUpperCase() + loose.slice(1)
    },
    fairnavigation() {
      let fairNav = this.fairs.map(fair => {
        let retVal = {
          id: fair._id,
          code: fair.idCode,
          name: fair[`displayName${this.language}`],
          // TODO: Add correct notification boolean (true|false)
          hasNotifications: fair._id === this.$route.params.code,
          children: []
        }

        fair.booths.forEach(booth => {
          let inAndExcludes = getLocalizationInExcludes(this.$i18n.locale)
          // TODO: Add correct notification boolean (true|false) for fairs too
          let localizedBooth = localize(
            booth,
            inAndExcludes.include,
            inAndExcludes.exclude
          )

          retVal.children.push({
            id: `${fair._id}_${localizedBooth.regiNr}`,
            name: `${localizedBooth.halleBezeichnung} / ${localizedBooth.standnummer}`,
            isNewRoute: true,
            route: {
              name: 'FairDetail',
              params: { code: fair.idCode, booth: localizedBooth.regiNr }
            }
          })
        })
        return retVal
      })

      if (this.$route.params.booth == 'new') {
        let currentFair = fairNav.find(
          item => item.code === this.$route.params.code
        )
        if (currentFair == undefined) {
          let fair = this.$store.getters['fair/getOneShopFairByCode'](
            this.$route.params.code
          )
          currentFair = {
            id: fair._id,
            code: fair.idCode,
            name: fair[`displayName${this.language}`],
            hasNotifications: false,
            children: []
          }
          fairNav.unshift(currentFair)
        }

        currentFair.children.unshift({
          name: this.$t('components.fairnavi.stand.new'),
          isNewRoute: true,
          route: {
            name: 'FairDetail',
            params: { code: currentFair.code, booth: 'new' }
          }
        })
      }
      return fairNav.filter(item=>item.children.length > 0)
    }
  },
  methods: {
    toggleMe(fair) {
      let idx = this.closedFairs.indexOf(fair.id)
      if (idx < 0) {
        this.closedFairs.push(fair.id)
      } else {
        this.closedFairs.splice(idx,1)
      }
    },
    getFairs() {
      if (!this.isLoading || this.fairs.length === 0) {
        this.$store.dispatch('fair/getOneShopFairs')
        this.$store.dispatch('fair/getWithBooths')
      }
    }
  },
  created() {
    this.getFairs()
  },
  components: {
    BosLoader
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$fairnavi-margin: 0 0 2em !default;

$fairnavi-loader-margin: 1em auto !default;
$fairnavi-loader-size: 3em !default;

$fairnavi-seperator: 1px solid $brand-gray !default;

$fairnavi-state-outerwidth: 30px !default;
$fairnavi-state-bg: $brand-blue !default;
$fairnavi-state-width: 0.75rem !default;
$fairnavi-state-height: 0.25rem !default;

$fairnavi-link-notification-outerwidth: 30px !default;
$fairnavi-link-notification-size: 0.6em !default;
$fairnavi-link-notification-bg: $brand-red !default;
$fairnavi-link-padding: 12px $fairnavi-link-notification-outerwidth 12px 0 !default;
$fairnavi-link-font-weight: $font-weight-bold !default;
$fairnavi-link-textdecoration: none !default;
$fairnavi-link-color: inherit !default;
$fairnavi-link-active-color: $brand-primary !default;

$fairnavi-sublink-padding: 10px 15px 10px 0 !default;
$fairnavi-sublink-font-size: $fairnavi-link-font-size !default;
$fairnavi-sublink-font-weight: $font-weight-normal !default;
$fairnavi-sublink-color: inherit !default;
$fairnavi-sublink-active-color: black !default;

.noclick {
  pointer-events: none;
}

.fair-navigation {
  display: block;
  margin: $fairnavi-margin;
  width: 100%;

  .loader {
    margin: $fairnavi-loader-margin;
    width: 1em;
    font-size: $fairnavi-loader-size;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      > a {
        display: block;
        position: relative;
        padding: $fairnavi-link-padding;
        font-size: $fairnavi-link-font-size;
        font-weight: $fairnavi-link-font-weight;
        color: $fairnavi-link-color;
        text-decoration: $fairnavi-link-textdecoration;
      }

      &.has-notifications {
        > a {
          &:after {
            display: block;
          }
        }
      }

      &.router-link-exact-active {
        > a {
          color: $fairnavi-link-active-color;
        }
      }

      ul {
        li {
          > a {
            padding: $fairnavi-sublink-padding;
            font-size: $fairnavi-sublink-font-size;
            font-weight: $fairnavi-sublink-font-weight;
            color: $fairnavi-sublink-color;

            &:after {
              margin: auto
                calc(
                  #{$fairnavi-link-notification-outerwidth * 0.5} - #{$fairnavi-link-notification-size *
                    0.25}
                );
              width: $fairnavi-link-notification-size * 0.5;
              height: $fairnavi-link-notification-size * 0.5;
            }
          }

          &.is-new-route {
            > a {
              font-size: $fairnavi-link-font-size;
              color: $fairnavi-link-color;
            }
          }

          &.router-link-active {
            > a {
              pointer-events: none;
              color: $fairnavi-sublink-active-color;
              font-weight: $fairnavi-link-font-weight;
            }
          }
        }
      }
    }
  }

  .navigation-list {
    border-top: $fairnavi-seperator;

    > li {
      position: relative;
      //      padding-left: $fairnavi-state-outerwidth;
      border-bottom: $fairnavi-seperator;

      a {
        padding-left: $fairnavi-state-outerwidth + 4px;

        &:hover {
          background-color: $brand-primary;
          color: black;
        }
      }

      &.router-link-active {
        > a {
          &:after {
            background-color: transparent;
          }
        }
      }

      > a {
        font-size: $fairnavi-fair-link-font-size;
        &:after {
          display: block;
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          margin-bottom: 0;
          margin-right: 0;
          background-image: url('~@/assets/images/icons/chevron_bold_right_primary_new.svg');
          background-size: 32px 30px;
          background-repeat: no-repeat;
          background-position: 10px 10px;
          width: 40px;
          height: 40px;

        }
        &:hover {
          &:after {
            background-image: url('~@/assets/images/icons/chevron_bold_down_black_new.svg');
          }
        }

        &.open {
          &:after{
            background-image: url('~@/assets/images/icons/chevron_bold_down_primary_new.svg');
          }
          &:hover {
            &:after {
              background-image: url('~@/assets/images/icons/chevron_bold_right_black_new.svg');
            }
          }
        }

      }

      > ul {
      }

      &.router-link-exact-active {
        &:after {
          display: none;
        }

        > ul {
          display: block;
        }
      }
    }
  }
}
</style>
